module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "30px 0 0 0"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("How Was the Church Service?")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#endorsements"
    }
  }, [_vm._v("Endorsements")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#preface"
    }
  }, [_vm._v("Preface")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-1-introduction"
    }
  }, [_vm._v("Chapter 1: Introduction")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#who-is-the-primary-audience-of-this-book"
    }
  }, [_vm._v("Who is the primary audience of this book?")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#what-is-the-purpose-of-writing-this-book"
    }
  }, [_vm._v("What is the purpose of writing this book?")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-2-how-can-i-be-scripture-wise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: How Can I Be Scripture-Wise?")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-3-what-was-the-text-or-passage-of-scripture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: What Was the Text or Passage of Scripture?")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-4-what-was-the-point-of-the-message",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: What Was the Point of the Message?")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-5-what-was-the-point-of-the-passage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: What Was the Point of the Passage?")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#observation-of-the-text-john-316-21.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation of the text: John 3:16 – 21.")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#john-317-grammatical-observation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 3:17 Grammatical Observation")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#john-318-grammatical-observation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 3:18 Grammatical Observation")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#john-319-grammatical-observation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 3:19 Grammatical Observation")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#john-320-grammatical-observation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 3:20 Grammatical Observation")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#john-321-grammatical-observation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 3:21 Grammatical Observation")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#other-important-observations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Important Observations")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#interpretation-of-the-text-john-316-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation of the text: John 3:16 – 21")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#application-of-the-text-john-316-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Application of the text: John 3:16 – 21")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-6-conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Conclusion")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0